import addressReducer from "./reducers/addressReducer";
import authReducer from "./reducers/authReducer";
import cardReducer from "./reducers/cardReducers";
import chatReducer from "./reducers/chatReducer";
import dashboardReducer from "./reducers/dashboardReducer";
import homeReducer from "./reducers/homeReducer";
import orderReducer from "./reducers/orderReducer";

const rootReducers = {
    home : homeReducer,
    auth : authReducer,
    card : cardReducer,
    order : orderReducer,
    dashboard: dashboardReducer,
    chat : chatReducer,
    address : addressReducer,
}
export default rootReducers;